import React, { useState, useEffect } from "react";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import NoFooterModal from "../../Common/NoFooterModal";
import Upload from "sushiweb/Icons/all/Upload";
import Textarea from "sushiweb/InputTypes/Textarea";
import { isValidated, isValNull } from "../../../utils";
import * as FleetCoachAppReleasesActions from "../../../store/actions/FleetCoachAppReleases";
import { setStatus } from "../../../store/actions/User";
import { getBulkCities, getCityList } from "../../../store/actions/City";
import FileUpload from "../../Common/FileUpload";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { bindActionCreators } from "redux";
import variables from "../../../constants/assets/variables";

const releaseScopes = [
  { key: "ReleaseScope_COUNTRY", label: "COUNTRY" },
  { key: "ReleaseScope_CITY", label: "CITY" },
  { key: "ReleaseScope_FLEET_COACH", label: "FLEET_COACH" },
];
const releaseStates = [
  { key: "UNRELEASED", label: "UNRELEASED" },
  // { key: "SOFT", label: "SOFT" },
  { key: "HARD", label: "HARD" },
  // { key: "STABLE", label: "STABLE" },
];

const launchAppReleaseMandatoryFields = [
  "app_version",
  "release_notes",
  "state",
  "release_scope",
];

const createEditReleaseMandatoryFields = [
  "app_version",
  "release_notes",
  "state",
];

const FleetCoachAppReleasesFormModal = (props) => {
  const [initialState, setInitialState] = useState({
    app_version: "",
    release_notes: "",
    state: "",
    release_scope: "",
    entities: [],
    csv_url: "",
  });
  const {
    modalState,
    activeRelease,
    handleClose,
    refreshList,

    // state props
    nextPageCity,

    // dispatch props
    setStatus,
    createAppRelease,
    editAppRelease,
    getApkUploadUrl,
    launchAppRelease,
    getCity,
    getCityList,
  } = props;

  const [preSignedUrl, setPreSignedUrl] = useState("");
  const [activeApkFile, setActiveApkFile] = useState(null);

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    if (modalState === "Edit") {
      const body = { id: activeRelease["id"], ...initialState };
      let validatedState = isValidated(body, createEditReleaseMandatoryFields);
      if (validatedState === "validated") {
        editAppRelease(body).then((res) => {
          handleClose();
          refreshList();
        });
      } else {
        setStatus({ type: "error", message: validatedState });
        return;
      }
    } else if (modalState === "Add") {
      const body = initialState;
      let validatedState = isValidated(body, createEditReleaseMandatoryFields);
      if (validatedState === "validated") {
        if (activeApkFile === null) {
          setStatus({ type: "error", message: "Please provide APK" });
          return;
        }
        const preSignedUrl = await getApkUploadUrl(initialState.app_version);
        setPreSignedUrl(preSignedUrl);
      } else {
        setStatus({ type: "error", message: validatedState });
        return;
      }
    } else if (modalState === "Launch") {
      if (initialState.state === "UNRELEASED") {
        setStatus({
          type: "error",
          message: "Release state cannot be UNRELEASED",
        });
        return;
      }
      let arr = { ...initialState }.entities;
      if (initialState.release_scope == "ReleaseScope_FLEET_COACH") {
        arr = initialState.entities.split(",");
      }

      const body = {
        ...initialState,
        entities: arr,
      };
      let validatedState = isValidated(body, launchAppReleaseMandatoryFields);

      if (validatedState === "validated") {
        if (
          body.release_scope != "ReleaseScope_COUNTRY" &&
          body.entities.length === 0
        ) {
          setStatus({
            type: "error",
            message: "Provide atleast one city / FC id",
          });
          return;
        }
        launchAppRelease(body).then((res) => {
          handleClose();
          refreshList();
        });
      } else {
        setStatus({ type: "error", message: validatedState });
        return;
      }
    }
  };

  const getReleaseStates = () => {
    if (modalState == "Add") {
      return releaseStates.filter((val) => val.key === "UNRELEASED");
    }
    if (modalState == "Edit") {
      if (activeRelease.state !== "UNRELEASED") {
        return releaseStates.filter((val) => val.key !== "UNRELEASED");
      }
    }
    return releaseStates;
  };

  useEffect(() => {
    if (modalState == "Edit" || modalState == "Launch") {
      setInitialState((prev) => {
        return { ...prev, ...activeRelease };
      });
    } else if (modalState === "Add") {
      setInitialState((prev) => {
        return { ...prev, state: "UNRELEASED" };
      });
    }
  }, []);

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Fleet Coach App release`}
      handleClose={handleClose}
      id="DriverShelterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="submitFleetCoachAppReleaseButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.app_version}
        data-testid="app_version"
        id="sushi-input"
        onChange={(e) => handleChange("app_version", e)}
        label="App Version"
        disabled={modalState === "Edit" || modalState === "Launch"}
      />
      <Textarea
        value={initialState.release_notes}
        data-testid="release_notes"
        id="sushi-textarea"
        onChange={(e) => handleChange("release_notes", e)}
        label="Release Notes"
        resize="none"
        innerWidth="100%"
        className="mb-20"
      />
      <PaginatedReactDropdown
        options={getReleaseStates()}
        data-testid="state"
        labelKey="label"
        valueKey="key"
        value={getInputLabel(initialState.state, releaseStates, "key", "label")}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="state"
        placeholder="Release State"
        showCross={true}
        id="state"
        disabled={modalState === "Edit"}
      />
      {modalState === "Launch" && (
        <>
          <PaginatedReactDropdown
            options={releaseScopes}
            data-testid="release_scope"
            labelKey="label"
            valueKey="key"
            value={getInputLabel(
              initialState.release_scope,
              releaseScopes,
              "key",
              "label"
            )}
            labelWidth="20%"
            handleChange={handleChange}
            keyToChange="release_scope"
            placeholder="Release Scope"
            showCross={true}
            id="release_scope"
          />
          {initialState.release_scope &&
            initialState.release_scope !== "ReleaseScope_COUNTRY" && (
              <>
                {initialState.release_scope === "ReleaseScope_CITY" && (
                  <InfiniteScrollDropdown
                    id="cityDropdownAppRelease"
                    multiple
                    priorityFlag={true}
                    appliedFilters={{}}
                    getActiveList={getCityList}
                    nextPage={nextPageCity}
                    resKey="cities"
                    modalState={"Edit"}
                    keyName="entities"
                    labelKey="city_name"
                    getDataLabelKey="city.city_name"
                    keyTypeToSet="id"
                    label="Cities"
                    handleChange={handleChange}
                    remoteSearchApplicable={true}
                    remoteSearchKey="startswith"
                    getActiveItemById={getCity}
                  />
                )}
                {initialState.release_scope === "ReleaseScope_FLEET_COACH" && (
                  <Textarea
                    value={initialState.entities}
                    data-testid="entities"
                    id="sushi-textarea"
                    onChange={(e) => handleChange("entities", e)}
                    label="Fleet Coach ids separated by comma"
                    resize="none"
                    innerWidth="100%"
                    className="mb-20"
                  />
                )}
              </>
            )}
        </>
      )}
      {modalState === "Add" && (
        <>
          <FileUpload
            className="mb-20"
            title="APK file"
            acceptTypes=".apk"
            presign_url={preSignedUrl}
            activeFile={activeApkFile}
            setActiveFile={setActiveApkFile}
            handleClose={handleClose}
            noAckCall={true}
            maxSize={100}
            handleFileUploadSuccess={() => {
              handleClose();
              createAppRelease(initialState);
              refreshList();
            }}
            UploadIcon={<Upload color={variables.black} />}
          />
          <br />
        </>
      )}
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { City } = state;
  return {
    cityList: City.cityList,
    nextPageCity: City.nextPage,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setStatus: bindActionCreators(setStatus, dispatch),
    createAppRelease: bindActionCreators(
      FleetCoachAppReleasesActions.createAppRelease,
      dispatch
    ),
    editAppRelease: bindActionCreators(
      FleetCoachAppReleasesActions.editAppRelease,
      dispatch
    ),
    getApkUploadUrl: bindActionCreators(
      FleetCoachAppReleasesActions.getApkUploadUrl,
      dispatch
    ),
    launchAppRelease: bindActionCreators(
      FleetCoachAppReleasesActions.launchAppRelease,
      dispatch
    ),
    getCity: bindActionCreators(getBulkCities, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FleetCoachAppReleasesFormModal);
